module.exports = __webpack_public_path__ + "img/digital_wire_bottom2.02fc8a89.svg";